import { Api } from 'vl-common/src/api';

type CreateCaseParams = {
  pat_guid: string;
  speccat: string;
  specarea: string;
  notes?: string;
  caseUrgency?: string;
  case_ref?: string;
  patient_sex?: string;
};

export const createCase = ({ pat_guid, speccat, specarea, notes, caseUrgency, case_ref }: CreateCaseParams) => {
  return () => Api.cases.createCase(pat_guid, speccat, specarea, case_ref, false, notes, caseUrgency);
};

export default createCase;
